import PropTypes from 'prop-types'
import cn from '../modules/cn'

function Wrapper(props) {
  const { onChange, enabled, ...p } = props
  if (onChange) {
    return (
      <button
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...p}
        type="button"
        aria-pressed={enabled}
        onClick={() => {
          onChange(!enabled)
        }}
      />
    )
  }
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <div {...p} />
}

Wrapper.propTypes = {
  onChange: PropTypes.func,
  enabled: PropTypes.bool,
}

Wrapper.defaultProps = {
  onChange: null,
  enabled: false,
}

function Toggle({
  enabled,
  label,
  showLabel,
  onChange,
  disabled,
  labelClassName,
  name,
}) {
  return (
    <div className="items-center flex">
      <Wrapper
        name={name}
        enabled={enabled}
        onChange={onChange}
        disabled={disabled}
        className={cn(
          `bg-gray-200 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full
        cursor-pointer transition-colors ease-in-out duration-200 dark:focus:ring-theme-500 dark:bg-gray-600
        focus:outline-none dark:focus:ring-offset-theme-500`,
          enabled && 'bg-theme-700 dark:bg-theme-500',
          disabled && 'pointer-events-none',
        )}
      >
        <span className="sr-only">
          {label}
        </span>
        <span
          aria-hidden="true"
          className={cn(
            `inline-block h-5 w-5 rounded-full bg-white shadow transform translate-x-0 ring-0
          transition ease-in-out duration-200`,
            enabled && 'translate-x-5',
          )}
        />
      </Wrapper>
      {showLabel && onChange && (
        <button
          type="button"
          onClick={() => {
            onChange(!enabled)
          }}
          disabled={disabled}
          className={cn(
            'text-sm font-medium text-gray-700 text-left ml-2 focus:outline-none',
            labelClassName,
          )}
        >
          {label}
        </button>
      )}
    </div>
  )
}

Toggle.propTypes = {
  label: PropTypes.string.isRequired,
  enabled: PropTypes.bool,
  showLabel: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  labelClassName: cn.propType,
  name: PropTypes.string,
}

Toggle.defaultProps = {
  enabled: false,
  showLabel: true,
  onChange: null,
  disabled: false,
  labelClassName: null,
  name: null,
}

export default Toggle
